<template>
  <div id="login" class="mainBody">
  </div>
</template>

<script>
export default {
  name: 'login',
  data () { // 所有的数据都写在里面
    return {
    }
  },
  created () {

  },
  destroyed () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
  .page_head{
    height: 70px;
    background-color: #ffffff;
    padding-left: 80px;
    font-size: 18px;
    font-weight: 500;
    line-height: 70px;
  }
  .page_body{
    height: calc(100% - 70px);
    background: url("../../../assets/img/backgroundImg.png") no-repeat center / cover;
    min-height: 500px;
  }
  .page_body .main_block{
    position: relative;
    width: 460px;
    height: 460px;
    top: 50%;
    left: 60%;
    transform: translateY(-230px);
    /*padding: 80px;*/
  }
  .main_block .bg_block{
    position: relative;
    width: 100%;
    height: 100%;
    background: linear-gradient(155deg, #FCFCFC 0%, #FCFCFC 0%, #F7F7F7 100%);
    opacity: 0.8;
    border-radius: 30px;
  }
  .main_block .content_block{
    position: absolute;
    top: 0;
    left: 0;
    padding: 72px 84px;
    width: calc(100% - 168px);
  }
  .tab_block{
    margin-bottom: 45px;
  }
  .tab_block li{
    display: inline;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    cursor: pointer;
    margin-right: 18px;
  }
  .tab_block li.selected{
    border-bottom: 3px solid #D71E1E;
  }
  .input_block{
    display: flex;
    width: 100%;
    margin-bottom: 36px;
    border-radius: 4px;
    overflow: hidden;
  }
  .input_block div{
    width: 42px;
    height: 42px;
    background: #303F59;
    text-align: center;
    line-height: 42px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .input_block span{
    width: 74px;
    text-align: center;
    line-height: 42px;
    background-color: #fff;
    padding: 0 10px;
    font-weight: 400;
    white-space: nowrap;
    cursor: pointer;
    position: absolute;
    right: 84px;
    border-radius: 0px 4px 4px 0px;
  }
  .input_block div img{
    width: 24px;
    height: 24px;
  }
  .input_block input{
    flex: 1;
    border: none;
    padding: 5px 10px;
    outline: none;
  }
  .content_block button{
    margin-top: 84px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/login/test.vue